import { useEffect } from "react";

type SeoMetaProps = {
  canonicalPath?: string | null;
  description: string;
  robots?: string;
  title: string;
};

const SITE_URL = "https://justicedrive.co";

const upsertMeta = (attr: "name" | "property", key: string, value: string) => {
  let tag = document.head.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", value);
};

const upsertCanonical = (href: string) => {
  let link = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
};

const removeCanonical = () => {
  document.head.querySelector('link[rel="canonical"]')?.remove();
};

export default function SeoMeta({ canonicalPath, description, robots = "index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1", title }: SeoMetaProps) {
  useEffect(() => {
    const canonicalUrl = canonicalPath ? `${SITE_URL}${canonicalPath}` : "";
    document.title = title;

    upsertMeta("name", "description", description);
    upsertMeta("name", "author", "JusticeDrive");
    upsertMeta("name", "robots", robots);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:site_name", "JusticeDrive");
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    if (canonicalUrl) {
      upsertMeta("property", "og:url", canonicalUrl);
      upsertCanonical(canonicalUrl);
    } else {
      document.head.querySelector('meta[property="og:url"]')?.remove();
      removeCanonical();
    }
  }, [canonicalPath, description, robots, title]);

  return null;
}
